import { put, call, takeLatest } from 'redux-saga/effects'

import { getPurchaseOrder as getPurchaseOrderApi } from 'Service/Api'

import * as PurchaseOrdersTypes from 'Redux/Types/PurchaseOrdersTypes'
import * as PurchaseOrdersActions from 'Redux/Actions/PurchaseOrdersActions'

function* getPurchaseOrder(purchaseOrderId) {
  try {
    const { data } = yield call(getPurchaseOrderApi, purchaseOrderId.payload)
    yield put(PurchaseOrdersActions.getPurchaseOrderSucceeded(data))
  } catch (errors) {
    yield put(PurchaseOrdersActions.getPurchaseOrderFailed(errors))
  }
}

export default function* PurchaseOrderSaga() {
  yield takeLatest(PurchaseOrdersTypes.GET_PURCHASE_ORDER, getPurchaseOrder)
}
